import { Component, AfterViewInit } from '@angular/core';
import { SwiperInitService } from 'src/app/shared/swiper-init.service';

@Component({
  selector: 'app-testimonial',
  templateUrl: './testimonial.component.html',
  styleUrls: ['./testimonial.component.scss']
})

export class TestimonialComponent implements AfterViewInit {
  constructor(private swiperInitService: SwiperInitService) { }
  ngAfterViewInit(): void {
    this.swiperInitService.initSliders();
  }
}

